// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"246":"a300b10e","444":"309fd451"}[chunkId] + ".chunk.css";
};